/* eslint-disable no-useless-escape */
// taken from https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
export const EMAIL_PATTERN =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const PHONE_PATTERN = /^[+\d\s/()]{8,}$/;
